<div #newsfeedContainer class="news-feed">
  <div
    class="news-bar"
    *ngIf="routing.isNewsaudit() && !(screenSize$ | async)?.isMobile"
  >
    <div class="cont">
      <div class="border-scroll"></div>
      <button mat-button>
        <span>Articles</span>
      </button>
    </div>
    <div class="audit-info">
      <div class="audit-info-events">
        <button mat-button>
          <span
            *ngIf="
              params.newstype &&
              params.newstype !== 'Flagged' &&
              params.newstype !== 'Dismissed'
            "
            >Events</span
          >
          <span
            *ngIf="
              params.newstype &&
              (params.newstype === 'Flagged' || params.newstype === 'Dismissed')
            "
            >Status</span
          >
        </button>
      </div>
      <div class="audit-info-entities">
        <button mat-button>
          <span
            [class.hidden]="params.tag"
            *ngIf="
              params.newstype &&
              params.newstype !== 'Flagged' &&
              params.newstype !== 'Dismissed'
            "
            >Participants</span
          >
          <span
            *ngIf="
              params.newstype &&
              (params.newstype === 'Flagged' || params.newstype === 'Dismissed')
            "
            >Subjects</span
          >
        </button>
      </div>
    </div>
    <div class="audit-actions">
      <div mat-icon-button class="export-audits"></div>
      <div mat-icon-button class="export-audits"></div>
      <div mat-icon-button class="export-audits"></div>
    </div>
  </div>

  <div
    class="news-bar"
    *ngIf="
      params.newstype === 'Chronological' ||
      params.newstype === 'Relevant' ||
      params.newstype === 'Stories' ||
      newstype === 'Relevant' ||
      newstype === 'Chronological' ||
      newstype === 'Stories'
    "
  >
    <div class="news-bar-search">
      <mat-icon>search</mat-icon>
      <input
        matInput
        autocomplete="off"
        placeholder="Search for keywords..."
        [formControl]="keywordSearch"
        matAutocompletePosition="below"
      />
    </div>
  </div>

  <div
    class="newscroll"
    [class.trending]="routing.isHot() || routing.isStoryReader()"
    #newscroll
    infiniteScroll
    [infiniteScrollThrottle]="10"
    [infiniteScrollDistance]="4"
    [scrollWindow]="false"
    (scrolled)="inScrolled()"
    (scroll)="inScrolling($event)"
  >
    <div class="loading" *ngIf="loading">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <div class="nodata" *ngIf="nodata && params">
      SOMETHING WENT WRONG, PLEASE TRY TO REFRESH THE PAGE
    </div>
    <div class="nodata" *ngIf="emptyPortfolio">
      ADD COMPANIES TO YOUR PORTFOLIO TO SEE THEIR NEWS
    </div>
    <div
      class="nodata"
      *ngIf="
        !loading &&
        !nodata &&
        !emptyPortfolio &&
        params &&
        newsfeed?.length === 0
      "
    >
      <span *ngIf="newstype === 'Bookmarked'"
        >NO BOOKMARKED ARTICLES FOUND IN THE CURRENT FILTERS</span
      >
      <span *ngIf="newstype === 'Flagged'"
        >NO FLAGGED ARTICLES FOUND IN THE CURRENT FILTERS</span
      >
      <span *ngIf="newstype === 'Dismissed'"
        >NO DISMISSED ARTICLES FOUND IN THE CURRENT FILTERS</span
      >
      <span *ngIf="showScoreEventEmptyNote"
        >NO ARTICLES FOUND FOR THIS EVENT IN ITS FULL SCORE WINDOW — CHECK YOUR
        LANGUAGE AND SOURCE FILTERS</span
      >
      <span
        *ngIf="
          !showScoreEventEmptyNote &&
          newstype !== 'Bookmarked' &&
          newstype !== 'Flagged' &&
          newstype !== 'Dismissed'
        "
        >NO ARTICLES FOUND</span
      >
    </div>

    <div
      class="nodata button-end"
      *ngIf="
        !loading &&
        !nodata &&
        params &&
        params.type &&
        newsfeed?.length < 5 &&
        newstype === 'Chronological'
      "
    >
      <button mat-stroked-button (click)="buildSearchQuery()">
        Find more articles <mat-icon>search</mat-icon>
      </button>
    </div>

    <app-news-feed-list
      *ngIf="
        !loading &&
        !nodata &&
        params &&
        newsfeed.length > 0 &&
        params.newstype !== 'Stories' &&
        newstype !== 'Stories' &&
        params.newstype !== 'Relevant' &&
        newstype !== 'Relevant'
      "
      [newsfeed]="newsfeed"
      [params]="params"
      [newstype]="newstype"
      [stars]="stars"
      [loadnews]="loadnews"
      (newsSelected)="goNews($event.news, $event.type)"
      (bookmarkToggled)="addStar($event)"
    ></app-news-feed-list>

    <app-story-view
      *ngIf="
        !loading &&
        !nodata &&
        params &&
        newsfeed?.length > 0 &&
        (params.newstype === 'Stories' ||
          newstype === 'Stories' ||
          params.newstype === 'Relevant' ||
          newstype === 'Relevant')
      "
      [stories]="newsfeed"
      [params]="params"
      [newstype]="newstype"
      [storyContentHeight]="storyContentHeight"
      (storySelected)="
        goNews({ story: $event.story, news: $event.news }, $event.type)
      "
    ></app-story-view>
  </div>

  <app-bookmark-manager
    [newsfeed]="newsfeed"
    [newstype]="params.newstype"
  ></app-bookmark-manager>

  <div
    class="scroload"
    *ngIf="
      !readyscroll &&
      newstype !== 'Bookmarked' &&
      newstype !== 'Flagged' &&
      newstype !== 'Dismissed' &&
      loading
    "
  >
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
